import cn from 'classnames'
import { DragNDropFileUploader } from 'legacy/lut/library/dragNDrop'
import { FC, useCallback } from 'react'

import { IDocumentFieldProps, IFileInputCallback } from './models'

import styles from './DocumentField.module.scss'

export const DocumentField: FC<IDocumentFieldProps> = ({
  tncUploadResult,
  sdcUploadResult,
  label,
  language,
  onDocumentFileChange,
}) => {
  const handleTermsAndConditionsChange = useCallback<IFileInputCallback>(
    (files) => {
      onDocumentFileChange({
        documentType: 'terms-and-conditions',
        file: files[0],
        language,
      })
    },
    [onDocumentFileChange, language]
  )

  const handleSelectiveDistributionCriteriaChange = useCallback<IFileInputCallback>(
    (files) => {
      onDocumentFileChange({
        documentType: 'selective-distributor-criteria',
        file: files[0],
        language,
      })
    },
    [onDocumentFileChange, language]
  )

  return (
    <div className={styles.root}>
      <div className={cn(styles.column, styles.label)}>
        <h4>{label}</h4>
      </div>
      <div className={cn(styles.column, styles.field)}>
        <DragNDropFileUploader
          multifiles={false}
          acceptedFormats=".pdf"
          changeFileLoader={handleTermsAndConditionsChange}
        />

        {tncUploadResult && (
          <span
            className={cn({
              [styles.errorMessage]: tncUploadResult.status === 'error',
              [styles.successMessage]: tncUploadResult.status === 'success',
            })}
          >
            {tncUploadResult.message}
          </span>
        )}
      </div>
      <div className={cn(styles.column, styles.field)}>
        <DragNDropFileUploader
          multifiles={false}
          acceptedFormats=".pdf"
          changeFileLoader={handleSelectiveDistributionCriteriaChange}
        />

        {sdcUploadResult && (
          <span
            className={cn({
              [styles.errorMessage]: sdcUploadResult.status === 'error',
              [styles.successMessage]: sdcUploadResult.status === 'success',
            })}
          >
            {sdcUploadResult.message}
          </span>
        )}
      </div>
    </div>
  )
}
